
/* Package JSON Import will be here */
import React, { useEffect, useState } from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector, useDispatch } from "react-redux";
import { Input, Row, Col, Form, Button, Checkbox, Typography } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import { toggleLoginOtpVerificationModal } from "reducers/sessionOtpVerification";
import { updateDirectMobileNumber } from "reducers/sessionOtpVerification";
import { ButtonSpinner } from "components/Spinner";
import { infoToast } from "utilities/utils";
import { errorToast } from "utilities/utils";
import ContractAgreementModel from "components/onboard/ContractAgreementModel";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Text } = Typography;
/* Const,Let & Var will be here */

const MobileNumberForm = (props) => {

  const [isShowContractAgreementModal, setIsShowContractAgreementModal] = useState(false);
  const [isContractAgreementAccepted, setIsContractAgreementAccepted] = useState(false);

  const { translate, session, sessionOtpVerification, appSettings } = useSelector((state) => ({
    translate: getTranslate(state.locale),
    session: state.session,
    sessionOtpVerification: state.sessionOtpVerification,
    appSettings: state.appSettings
  }));

  const dispatch = useDispatch();

  /* Show alert message when page is mounted */
  useEffect(() => {
    infoToast({ content: translate("session.signIn.note") });
  }, [])

  const onSubmitMobileNumber = (values) => {
    if (!appSettings.isEnableOnboardContractAgreement || (appSettings.isEnableOnboardContractAgreement && isContractAgreementAccepted)) {
      /* If - Show the OTP modal if the otpAuthAfterLogin is set to true */
      /* Else - The otpAuthAfterLogin is set to false directly update the mobile number against the retailer - JNJ scenario */
      if (appSettings.otpAuthAfterLogin)
        dispatch(toggleLoginOtpVerificationModal(session.tempUser, session.tempToken, values.mobileNo));
      else
        dispatch(updateDirectMobileNumber(values.mobileNo, session.tempToken, session.tempUser));
    }
    else {
      errorToast({ content: translate("contractAgreement.validationMsg") });
    }
  }

  const openContractAgreement = () => {
    if (!isContractAgreementAccepted)
      setIsShowContractAgreementModal(true);
  }

  const onAgreeContractAgreement = () => {
    setIsContractAgreementAccepted(true);
    setIsShowContractAgreementModal(false);
  }

  return (
    <React.Fragment>
      <Form className="signIn-page"
        name="newLoginMobileNumberForm"
        onFinish={onSubmitMobileNumber}
      >
        <Row className="display-row-block">
          <Col span={24} md={24} className="font-12 p-1 font-bold">
            {translate("session.common.mobileNumber")}
          </Col>

          <Col span={24} md={24}>
            <Form.Item
              name="mobileNo"
              rules={[{ required: true, pattern: /^(\+\d{1,3}[- ]?)?\d{10}$/, message: translate("common.formValidation.mobileNumberValidation") }]}
            >
              <Input
                size="large"
                inputMode="numeric"
                placeholder={translate("session.common.enterMobileNumber")}
                className="rounded sign-in-input-height round-radius"
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Check for isEnableOnboardContractAgreement config, If the config is true then enable the checkbox */}
        {appSettings.isEnableOnboardContractAgreement &&
          <div className="p-2">
            <Checkbox checked={isContractAgreementAccepted} onChange={openContractAgreement}>
              <Text>{translate("contractAgreement.checkBoxMsg")}</Text>
            </Checkbox>
          </div>
        }

        <Row>
          <Col span={24} className="text-center">
            <Form.Item>
              <Button
                className="sign-in-btn-width mb-1"
                disabled={sessionOtpVerification.isLoading}
                type="primary"
                htmlType="submit"
                shape="round"
              >
                {translate("session.signIn.onboard")}
                {sessionOtpVerification.isLoading && <ButtonSpinner />}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      {(isShowContractAgreementModal && appSettings.isEnableOnboardContractAgreement) &&
        <ContractAgreementModel
          isShowContractAgreementModal={isShowContractAgreementModal}
          onAgreeContractAgreement={onAgreeContractAgreement}
        />
      }
    </React.Fragment>
  );
};

export default MobileNumberForm;